// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dfcc5463","977":"e660bc8e"}[chunkId] + ".chunk.js";
};